// Selectors
import { ApplicationState } from '../../store';


export const authSelector = (state: ApplicationState) => state.authState

